<template>
  <section id="company-activities" class="company-activities">
    <div class="imgDIV">
      <img src="../../assets/images/line.png" class="line" />
      <img
        src="../../assets/images/organization/Organization Structure.png"
        class="imgtitle"
      />
      <img src="../../assets/images/line.png" class="line" />
    </div>
    <div>
      <img
        style="width: 785px;"
        src="../../assets/images/organization/str.png"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutUs",
  data() {
    return {};
  },
  methods: {
    test() {
      this.$axios
        .get(
          "https://mini.kingboya.com:10540/eoa/im/api/getList?userId=1483664524254736386&token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NDI1ODM4MjQsInVzZXJuYW1lIjoia2luZyJ9.oK5GVVVtY7A5MxDc-ydcO2_FqaTkGRQHvR9ELLGzJ2g&_=1642584621304"
        )
        .then(function(response) {
          // console.log(response);
        });
    },
    opento(url) {
      window.open(url);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.company-activities {
  margin-top: -8px;
}

.imgtitle {
  width: 50%;
  height: 80px;
  margin-bottom: 10px;
}

.read-more-btn {
  font-family: "Oswald-Light";
}

/deep/.activity .read-more-btn {
  font-size: 18px;
  margin-bottom: 10px;
}

.act-image-wrapper {
  height: 195px;
  overflow: hidden;
  padding: 10px;
  background-color: #ffffff;
  box-shadow: 0px 0px 34px rgb(0 0 0 / 10%);
  margin: -24px -24px 10px;
}

.act-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 8;
  /*想省略几行就写几*/
  -webkit-box-orient: vertical;
  margin-top: 5px;
  margin-bottom: 25px;
  font-family: "pala";
  font-size: 15px;
  color: #000;
}

.act-title {
  height: 105px;
  font-size: 18px;
  margin-bottom: 10px;
  font-family: "Oswald-Light";
  font-weight: bold;
  color: #000000;
  line-height: 36px;
}

.topline {
  width: 1px;
  height: 60px;
  margin: 0 auto;
  margin-bottom: 30px;
}

.imgDIV {
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: space-around;

  .line {
    height: 1px;
    width: 25%;
  }
}
</style>
